import React from 'react';
import PropTypes from 'prop-types';
import { DownloadArrowDirectionEnum } from '../DownloadOverlayConstants';

const DownloadArrow = (props) => {
  let color = '#5cb85c';
  if (props.active) {
    color = '#7cf26a';
  }

  let display = 'inline-block';
  let rotation = 0;
  switch (props.downloadArrowDirection) {
    case DownloadArrowDirectionEnum.UP:
      display = 'block';
      rotation = -45;
      break;
    case DownloadArrowDirectionEnum.RIGHT:
      rotation = 45;
      break;
    case DownloadArrowDirectionEnum.DOWN:
      display = 'block';
      rotation = 135;
      break;
    case DownloadArrowDirectionEnum.LEFT:
      rotation = -135;
      break;
    default:
      rotation = 0;
  }

  const styles = {
    backgroundColor: 'transparent',
    borderColor: color,
    borderStyle: 'solid',
    borderWidth: '8px 8px 0 0',
    display,
    height: 14,
    position: 'relative',
    transform: `rotate(${rotation}deg)`,
    WebKitTransform: `rotate(${rotation}deg)`,
    MozTransform: `rotate(${rotation}deg) perspective(1px)`, // adding perspective to remove border seams
    msTransform: `rotate(${rotation}deg)`,
    verticalAlign: top,
    width: 14,
  };

  return (
    <div className={'download-arrow'} style={styles} />
  );
};


DownloadArrow.propTypes = {
  active: PropTypes.bool.isRequired,
  downloadArrowDirection: PropTypes.oneOf([
    DownloadArrowDirectionEnum.UP,
    DownloadArrowDirectionEnum.RIGHT,
    DownloadArrowDirectionEnum.DOWN,
    DownloadArrowDirectionEnum.LEFT,
  ]).isRequired,
};

export default DownloadArrow;




// WEBPACK FOOTER //
// ./src-react/download-overlay/components/DownloadArrow.jsx